<div class="sync-product-card">
  <div class="sync-product-card-id">
    Id: {{ productCardData().id }}
  </div>
  <div class="sync-product-card-img-wrapper">
    <img
      class="sync-product-card-img"
      width="150"
      height="150"
      alt=""
      [src]="getImg()"
    >
  </div>
  <div class="sync-product-card-title">
    {{ productCardData().title }}
  </div>
  <div class="sync-product-card-params">
    @for (param of productCardParamsData; track $index) {
      <div
        class="sync-product-card-param"
        [class.sync-product-card-param-set]="isSearchParam(param.fieldName)"
      >
        <div class="sync-product-card-param-label">
          {{ param.label }}:
        </div>
        <div class="sync-product-card-param-value">
          {{ getParamData(param.fieldName) }}
        </div>
      </div>
    }
  </div>

  <div class="buttons-container">
    <a
      mat-button
      class="save-button"
      target="_blank"
      [href]="getUrlProductCard()"
    >
      <mat-icon>
        share
      </mat-icon>
      Открыть
    </a>
    <button
      mat-button
      [color]="isDetachKey() ? 'warn' : 'primary'"
      (click)="handleBtn()"
    >
      <mat-icon>
        {{ isDetachKey() ? 'link_off' : 'link' }}
      </mat-icon>
      {{ isDetachKey() ? 'Отвязать' : 'Привязать' }}
    </button>
  </div>
</div>
